import State from "../lib/State";

import * as PIXI from "pixi.js";
import signals from "signals";
import ServiceLocator from "../ServiceLocator";

import FontFaceObserver from "fontfaceobserver";
import { ISoundLoadGroup, track_id } from "../service/AudioManager";
import { device_orientation_type } from "../service/DeviceOrientation";
import Button from "../lib/Button";


export default class PreloaderState extends State
{
    // #region Attributes //

    // private:

    private _resources: any = null;

    private _root: PIXI.Container = null;

    private _bg: PIXI.Sprite = null;
    private _gameLogo: PIXI.Sprite = null;

    private _loadingBarContainer: PIXI.Container = null;
    private _loadingBarMask: PIXI.Graphics = null;

    private _arrFontFaceObserver: Array<FontFaceObserver> = null;
    private _loadedFountCount: number = null;
    
    // Signals.
    private _onComplete: signals.Signal = new signals.Signal();

    // #endregion //


    // #region Properties //

    // Signals.
    public get onComplete(): signals.Signal { return this._onComplete; }

    // #endregion //


    // #region Methods //

    // public:

    public constructor() 
    { 
        super(); 
    }

    public onEnter( params: Object = null ): void
    {
        this._resources = {};
        Object.assign( this._resources, PIXI.Loader.shared.resources );

        this._root = new PIXI.Container();
        ServiceLocator.app.root.addChild( this._root );

        this._bg = new PIXI.Sprite( this._resources.loading_bg.texture );
        this._bg.anchor.set( 0.5 );
        this._bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( this._bg );

        this._gameLogo = new PIXI.Sprite( this._resources.game_logo.texture );
        //this._gameLogo.position.set( ServiceLocator.app.width * 0.5, 342 - 220 ); // V2:
        this._gameLogo.position.set( ServiceLocator.app.width * 0.5, 342 - 200 ); 
        this._gameLogo.anchor.set( 0.5, 0 );
        this._gameLogo.scale.set( 0.8 );
        this._root.addChild( this._gameLogo );

        this._loadingBarContainer = new PIXI.Container();
        this._loadingBarContainer.position.set( ServiceLocator.app.width * 0.5, 970 );
        this._root.addChild( this._loadingBarContainer );

        let loadingBarBase: PIXI.Sprite = new PIXI.Sprite( this._resources.loading_bar_base.texture );
        loadingBarBase.anchor.set( 0.5, 0.5 );
        this._loadingBarContainer.addChild( loadingBarBase );

        let loadingBar: PIXI.Container = new PIXI.Container();
        this._loadingBarContainer.addChild( loadingBar );
        //
        let bar: PIXI.Sprite = new PIXI.Sprite( this._resources.loading_bar.texture );
        bar.anchor.set( 0, 0.5 );
        bar.position.set( -bar.width * 0.5 + 2.5, -2.5 );
        loadingBar.addChild( bar );
        //
        this._loadingBarMask = new PIXI.Graphics();
        this._loadingBarMask.position.set( bar.x, bar.y - bar.height * 0.5 );
        this._loadingBarMask.beginFill( 0xff3300 );
        this._loadingBarMask.drawRect( 0, 0, bar.width, bar.height );
        this._loadingBarMask.endFill();
        this._loadingBarMask.scale.x = 0;
        loadingBar.addChild( this._loadingBarMask );
        loadingBar.mask = this._loadingBarMask;

        this._loadedFountCount = 0;
        this._arrFontFaceObserver = [];
        const kArrFontId: Array<string> = [ "college_tm_regular", "jaro_regular", "teko_regular" ];
        for ( let fontId of kArrFontId )
        {
            let ffo: FontFaceObserver = new FontFaceObserver( fontId );
            ffo.load( null, 10000 ).then( () => { this._loadedFountCount += 1; } ).catch( () => { this._loadedFountCount += 1; } );
            this._arrFontFaceObserver.push( ffo );
        }

        // Preload game assets.
        PIXI.Loader.shared.reset();
        PIXI.Loader.shared.defaultQueryString = ServiceLocator.saved.data.version.toString();
        //
        PIXI.Loader.shared
            //
            /*.add( "test1x", "resources/img/test.png" ) // TEST:
            .add( "test2x", "resources/img/test.png" )
            .add( "test4x", "resources/img/test@4x.png" )*/
            //
            /*.add(
                "teapot",
                "resources/model/teapot.gltf"
                //"https://raw.githubusercontent.com/jnsmalm/pixi3d-examples/master/assets/teapot/teapot.gltf"
            )
            .add(
                "vignette",
                "https://raw.githubusercontent.com/jnsmalm/pixi3d-examples/master/assets/vignette.png"
            )*/
            //.add( "dart", "resources/model/dart/scene.gltf" )
            //.add( "dartboard", "resources/model/board/scene.gltf" )
            //
            //.add( "gameplay_bg", "resources/img/gameplay/bg@2x.png" )
            .add( "dart_shadow", "resources/img/gameplay/dart_shadow.png" )
            //.add( "dartboard_texture", "resources/img/gameplay/Element_DartBoard_Base.png" );
        for ( let i: number = 0; i < 50; ++i )
        {
            PIXI.Loader.shared.add( "dart_" + i.toString(), "resources/model/dart/" + i.toString() + "/untitled.gltf" );
            PIXI.Loader.shared.add( "alt_dart_texture_" + i.toString(), "resources/model/dart/" + i.toString() + "/1.png" );
        }
        for ( let i: number = 0; i < 13; ++i )
        {
            PIXI.Loader.shared.add( "vfx_hit_" + i.toString(), "resources/img/gameplay/vfx_hit/" + i.toString() + ".png" );
        }
        //
        PIXI.Loader.shared
            .add( "button_back", "resources/img/common/button_back@2x.png" )
            .add( "button_back_pressed", "resources/img/common/button_back_pressed@2x.png" )
            .add( "settings_toggle_base", "resources/img/common/settings/settings_toggle_base@2x.png" )
            .add( "settings_toggle_base_short", "resources/img/common/settings/settings_toggle_base_short@2x.png" )
            .add( "button_settings", "resources/img/common/settings/button_settings@2x.png" )
            .add( "button_settings_pressed", "resources/img/common/settings/button_settings_pressed@2x.png" )
            .add( "button_music", "resources/img/common/settings/button_music_on@2x.png" )
            .add( "button_music_pressed", "resources/img/common/settings/button_music_on_pressed@2x.png" )
            .add( "button_music_off", "resources/img/common/settings/button_music_off@2x.png" )
            .add( "button_music_off_pressed", "resources/img/common/settings/button_music_off_pressed@2x.png" )
            .add( "button_sfx", "resources/img/common/settings/button_sound_on@2x.png" )
            .add( "button_sfx_pressed", "resources/img/common/settings/button_sound_on_pressed@2x.png" )
            .add( "button_sfx_off", "resources/img/common/settings/button_sound_off@2x.png" )
            .add( "button_sfx_off_pressed", "resources/img/common/settings/button_sound_off_pressed@2x.png" )
            .add( "button_home", "resources/img/common/settings/button_home@2x.png" )
            .add( "button_home_pressed", "resources/img/common/settings/button_home_pressed@2x.png" )
            .add( "button_tutorial", "resources/img/common/settings/button_tutorial@2x.png" )
            .add( "button_tutorial_pressed", "resources/img/common/settings/button_tutorial_pressed@2x.png" )
            .add( "avatar_unknown", "resources/img/common/avatar/unknown@2x.png" )
            .add( "avatar_you", "resources/img/common/avatar/you@2x.png" )
        for ( let i: number = 0; i < 12; ++i )
        {
            PIXI.Loader.shared.add( "avatar_" + i.toString(), "resources/img/common/avatar/" + i.toString() + "@2x.svg" );
        }
        //
        PIXI.Loader.shared
            .add( "lobby_bg", "resources/img/lobby/lobby_background@2x.png" )
            .add( "lobby_button_mode_301", "resources/img/lobby/button_mode_301@2x.png" )
            .add( "lobby_button_mode_301_pressed", "resources/img/lobby/button_mode_301_pressed@2x.png" )
            .add( "lobby_button_mode_classic", "resources/img/lobby/button_mode_classic@2x.png" )
            .add( "lobby_button_mode_classic_pressed", "resources/img/lobby/button_mode_classic_pressed@2x.png" )
            .add( "lobby_button_mode_offline", "resources/img/lobby/button_mode_offline@2x.png" )
            .add( "lobby_button_mode_offline_pressed", "resources/img/lobby/button_mode_offline_pressed@2x.png" )
            .add( "lobby_button_mode_w-friens", "resources/img/lobby/button_mode_w-friens@2x.png" )
            .add( "lobby_button_mode_w-friens_pressed", "resources/img/lobby/button_mode_w-friens_pressed@2x.png" )
            .add( "lobby_button_shop", "resources/img/lobby/button_shop@2x.png" )
            .add( "lobby_button_shop_pressed", "resources/img/lobby/button_shop_pressed@2x.png" )
            .add( "lobby_icon_exclamation", "resources/img/lobby/icon_exclamation@2x.png" )
            .add( "lobby_level_base", "resources/img/lobby/level_base@2x.png" )
            .add( "lobby_xp_bar", "resources/img/lobby/xp_bar@2x.png" )
            .add( "lobby_user_hud_base", "resources/img/lobby/user_hud_base@2x.png" )
            .add( "lobby_avatar_base", "resources/img/lobby/avatar_base@2x.png" )
            //
            .add( "button_mode_301", "resources/img/matchmaking/button_mode_301@2x.png" )
            .add( "button_mode_301_pressed", "resources/img/matchmaking/button_mode_301_pressed@2x.png" )
            .add( "button_mode_301_off", "resources/img/matchmaking/button_mode_301_off@2x.png" )
            .add( "button_mode_classic", "resources/img/matchmaking/button_mode_classic@2x.png" )
            .add( "button_mode_classic_pressed", "resources/img/matchmaking/button_mode_classic_pressed@2x.png" )
            .add( "button_mode_classic_off", "resources/img/matchmaking/button_mode_classic_off@2x.png" )
            .add( "button_play", "resources/img/matchmaking/button_play@2x.png" )
            .add( "button_play_pressed", "resources/img/matchmaking/button_play_pressed@2x.png" )
            .add( "icon_tip", "resources/img/matchmaking/icon_tip@2x.png" )
            .add( "url_base", "resources/img/matchmaking/url_base@2x.png" )
            .add( "loading_circle_ext", "resources/img/matchmaking/loading_circle_ext@2x.png" )
            .add( "loading_circle_int", "resources/img/matchmaking/loading_circle_int@2x.png" )
            .add( "matchmaking_background_01", "resources/img/matchmaking/matchmaking_background_01@2x.png" )
            .add( "matchmaking_background_02", "resources/img/matchmaking/matchmaking_background_02@2x.png" )
            .add( "matchmaking_avatar_base", "resources/img/matchmaking/avatar_base@2x.png" )
            .add( "matchmaking_avatar_outline", "resources/img/matchmaking/avatar_white_outline@2x.png" )
            .add( "vs", "resources/img/matchmaking/vs@2x.png" )
            .add( "vs_background_effect", "resources/img/matchmaking/vs_background_effect@2x.png" )
            //
            .add( "popup_base", "resources/img/popup/dark_base@2x.png" )
            .add( "popup_button_yes", "resources/img/popup/button_yes@2x.png" )
            .add( "popup_button_yes_pressed", "resources/img/popup/button_yes_pressed@2x.png" )
            .add( "popup_button_no", "resources/img/popup/button_no@2x.png" )
            .add( "popup_button_no_pressed", "resources/img/popup/button_no_pressed@2x.png" )
            .add( "popup_button_ok", "resources/img/popup/button_ok@2x.png" )
            .add( "popup_button_ok_pressed", "resources/img/popup/button_ok_pressed@2x.png" )
            //
            .add( "avatar_level_up_base", "resources/img/game_over/avatar_level-up_base_yellow@2x.png" )
            .add( "avatar_lose_base", "resources/img/game_over/avatar_lose_base_white@2x.png" )
            .add( "avatar_win_base", "resources/img/game_over/avatar_win_base_yellow@2x.png" )
            .add( "button_claim", "resources/img/game_over/button_claim@2x.png" )
            .add( "button_claim_pressed", "resources/img/game_over/button_claim_pressed@2x.png" )
            .add( "button_claim_x2", "resources/img/game_over/button_claim_x2@2x.png" )
            .add( "button_claim_x2_pressed", "resources/img/game_over/button_claim_x2_pressed@2x.png" )
            .add( "go_button_home", "resources/img/game_over/button_home@2x.png" )
            .add( "go_button_home_pressed", "resources/img/game_over/button_home_pressed@2x.png" )
            .add( "button_retry", "resources/img/game_over/button_retry@2x.png" )
            .add( "button_retry_pressed", "resources/img/game_over/button_retry_pressed@2x.png" )
            .add( "button_accept_rematch", "resources/img/game_over/button_play@2x.png" )
            .add( "button_accept_rematch_pressed", "resources/img/game_over/button_play_pressed@2x.png" )
            .add( "icon_coin", "resources/img/game_over/icon_coin@2x.png" )
            .add( "level_bar", "resources/img/game_over/level_bar@2x.png" )
            .add( "level_bar_base", "resources/img/game_over/level_bar_base@2x.png" )
            .add( "go_level_base", "resources/img/game_over/level_base@2x.png" )
            .add( "level_up", "resources/img/game_over/level_up@2x.png" )
            .add( "popup_base_lose", "resources/img/game_over/pop-up_base_lose@2x.png" )
            .add( "popup_base_win", "resources/img/game_over/pop-up_base_win@2x.png" )
            .add( "popup_base_draw", "resources/img/game_over/pop-up_base_draw@2x.png" )
            .add( "reward_label", "resources/img/game_over/reward_label@2x.png" )
            .add( "win_level_label", "resources/img/game_over/win_level_label@2x.png" )
            .add( "winner_badge", "resources/img/game_over/winner_badge@2x.png" )
            .add( "you_lose", "resources/img/game_over/you_lose@2x.png" )
            .add( "you_win", "resources/img/game_over/you_win@2x.png" )
            .add( "p1_wins", "resources/img/game_over/p1_wins@2x.png" )
            .add( "p2_wins", "resources/img/game_over/p2_wins@2x.png" )
            .add( "draw", "resources/img/game_over/draw@2x.png" )
            .add( "rematch", "resources/img/game_over/rematch@2x.png" )
            .add( "score_base_lose", "resources/img/game_over/score_base_lose@2x.png" )
            .add( "score_base_win", "resources/img/game_over/score_base_win@2x.png" )
            .add( "button_ask_rematch", "resources/img/game_over/button_ask_rematch@2x.png" )
            .add( "button_ask_rematch_pressed", "resources/img/game_over/button_ask_rematch_pressed@2x.png" )
            .add( "rematch_bubble", "resources/img/game_over/rematch_bubble@2x.png" );
            //
        for ( let i: number = 0; i < 3; ++i )
        {
            PIXI.Loader.shared.add( "go_vfx_draw_base_" + i.toString(), "resources/img/game_over/vfx_draw_base/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "go_vfx_win_base_" + i.toString(), "resources/img/game_over/vfx_win_base/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "go_vfx_lose_base_" + i.toString(), "resources/img/game_over/vfx_lose_base/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "go_vfx_banner_" + i.toString(), "resources/img/game_over/vfx_banner/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "go_vfx_versus_" + i.toString(), "resources/img/game_over/vfx_versus/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "go_vfx_win_frame_" + i.toString(), "resources/img/game_over/vfx_win_frame/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 4; ++i )
        {
            PIXI.Loader.shared.add( "go_vfx_profile_" + i.toString(), "resources/img/game_over/vfx_profile/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 39; ++i )
        {
            PIXI.Loader.shared.add( "confetti_" + i.toString(), "resources/img/game_over/confetti/" + i.toString() + "@2x.png" );
        }
        //
        PIXI.Loader.shared
            .add( "hand_device_logo", "resources/img/hand_device/logo@2x.png" )
            .add( "button_ready", "resources/img/hand_device/button_ready@2x.png" )
            .add( "button_ready_pressed", "resources/img/hand_device/button_ready_pressed@2x.png" );
            //
        PIXI.Loader.shared
            .add( "hud_dart_p1", "resources/img/gameplay/hud/dart_p1@2x.png" )
            .add( "hud_dart_p2", "resources/img/gameplay/hud/dart_p2@2x.png" )
            .add( "hud_round_dot_off", "resources/img/gameplay/hud/dot_small_off@2x.png" )
            .add( "hud_round_dot_on", "resources/img/gameplay/hud/dot_small_on@2x.png" )
            .add( "hud_round_base", "resources/img/gameplay/hud/round_label_small@2x.png" )
            .add( "hud_your_turn_label", "resources/img/gameplay/hud/your-turn_label@2x.png" )
            .add( "hud_active_player", "resources/img/gameplay/hud/active_player@2x.png" )
            .add( "hud_bottom_label", "resources/img/gameplay/hud/bottom_label@2x.png" )
            .add( "hud_cooldown_bar", "resources/img/gameplay/hud/cooldown_bar@2x.png" )
            .add( "hud_cooldown_base", "resources/img/gameplay/hud/cooldown_base@2x.png" )
            .add( "hud_banner_0", "resources/img/gameplay/hud/banner/0@2x.png" )
            .add( "hud_banner_1", "resources/img/gameplay/hud/banner/1@2x.png" )
            .add( "hud_banner_2", "resources/img/gameplay/hud/banner/2@2x.png" )
            .add( "hud_badge_2x", "resources/img/gameplay/hud/badge_2x@2x.png" )
            .add( "hud_badge_3x", "resources/img/gameplay/hud/badge_3x@2x.png" )
            .add( "hud_score_added_label", "resources/img/gameplay/hud/score_added_label@2x.png" )
            .add( "hud_time_left_base", "resources/img/gameplay/hud/time_left_base@2x.png" )
            .add( "hud_user_hud_base_slice_00", "resources/img/gameplay/hud/user_hud_base_slice_02@2x.png" )
            .add( "hud_user_hud_base_slice_01", "resources/img/gameplay/hud/user_hud_base_slice_03@2x.png" )
            .add( "hud_bust", "resources/img/gameplay/hud/bust@2x.png" )
            .add( "hud_bullseye", "resources/img/gameplay/hud/bullseye@2x.png" )
            .add( "hud_checkout", "resources/img/gameplay/hud/checkout@2x.png" )
            .add( "hud_tutorial_hand", "resources/img/gameplay/hud/tutorial_hand@2x.png" )
            .add( "test0", "resources/img/gameplay/hud/test0.png" );
        for ( let i: number = 0; i < 7; ++i )
        {
            PIXI.Loader.shared.add( "hud_mask_banner_in_" + i.toString(), "resources/img/gameplay/hud/mask_banner/in/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "hud_mask_banner_out_" + i.toString(), "resources/img/gameplay/hud/mask_banner/out/" + i.toString() + ".png" );
        }
            //
        PIXI.Loader.shared
            .add( "shop_background", "resources/img/shop/background@2x.png" )
            .add( "shop_button_base", "resources/img/shop/button_base@2x.png" )
            .add( "shop_button_base_pressed", "resources/img/shop/button_base_pressed@2x.png" )
            .add( "shop_button_boards", "resources/img/shop/button_boards@2x.png" )
            .add( "shop_button_boards_pressed", "resources/img/shop/button_boards_pressed@2x.png" )
            .add( "shop_button_darts", "resources/img/shop/button_darts@2x.png" )
            .add( "shop_button_darts_pressed", "resources/img/shop/button_darts_pressed@2x.png" )
            .add( "shop_button_lock_base", "resources/img/shop/button_lock_base@2x.png" )
            .add( "shop_button_normal", "resources/img/shop/button_normal@2x.png" )
            .add( "shop_button_not_enough_money_base", "resources/img/shop/button_not_enough_money_base@2x.png" )
            .add( "shop_button_not-enough-money", "resources/img/shop/button_not-enough-money@2x.png" )
            .add( "shop_button_selected_base", "resources/img/shop/button_selected_base@2x.png" )
            .add( "shop_button_selected_base_pressed", "resources/img/shop/button_selected_base_pressed@2x.png" )
            .add( "shop_icon_lock", "resources/img/shop/icon_lock@2x.png" )
            .add( "shop_product_base", "resources/img/shop/shop_product_base@2x.png" )
            .add( "shop_product_base_lock", "resources/img/shop/shop_product_base_lock@2x.png" )
            .add( "shop_product_locked", "resources/img/shop/shop_product_locked@2x.png" )
            .add( "shop_product_selected", "resources/img/shop/shop_product_selected@2x.png" );
        for ( let i: number = 0; i < 50; ++i )
        {
            PIXI.Loader.shared.add( "shop_dart_item_" + i.toString(), "resources/img/shop/dart/" + i.toString() + "@2x.png" );
            PIXI.Loader.shared.add( "shop_board_item_" + i.toString(), "resources/img/shop/board/" + i.toString() + "@2x.png" );
        }
            //
        for ( let i: number = 0; i < 5; ++i )
        {
            PIXI.Loader.shared.add( "hud_user_base_" + i.toString(), "resources/img/gameplay/hud/vfx_user_base/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 6; ++i )
        {
            PIXI.Loader.shared.add( "gp_highlight_" + i.toString(), "resources/img/gameplay/dartboard/highlight_0" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "gp_outline_" + i.toString(), "resources/img/gameplay/dartboard/outline_0" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 50; ++i )
        {
            PIXI.Loader.shared.add( "gp_bg_" + i.toString(), "resources/img/gameplay/bg/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "gp_inner_" + i.toString(), "resources/img/gameplay/dartboard/inner/" + i.toString() + ".png" );
            PIXI.Loader.shared.add( "gp_frame_" + i.toString(), "resources/img/gameplay/dartboard/frame/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 9; ++i )
        {
            PIXI.Loader.shared.add( "gp_mask_bg_" + i.toString(), "resources/img/gameplay/mask_bg/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 10; ++i )
        {
            PIXI.Loader.shared.add( "gp_mask_inner_" + i.toString(), "resources/img/gameplay/dartboard/mask_inner/" + i.toString() + ".png" );
        }
        for ( let i: number = 0; i < 6; ++i )
        {
            PIXI.Loader.shared.add( "gp_mask_frame_" + i.toString(), "resources/img/gameplay/dartboard/mask_frame/" + i.toString() + ".png" );
        }
            //
        PIXI.Loader.shared.add( "button_arrow", "resources/img/tutorial/arrow@2x.png" )
            .add( "button_arrow_pressed", "resources/img/tutorial/arrow_pressed@2x.png" )
            .add( "button_close", "resources/img/tutorial/button_close@2x.png" )
            .add( "button_close_pressed", "resources/img/tutorial/button_close_pressed@2x.png" )
            .add( "tut_dot", "resources/img/tutorial/tut_dot@2x.png" )
            .add( "tut_dot_base", "resources/img/tutorial/tut_dot_base@2x.png" );
        for ( let i = 0; i < 3; ++i )
        {
            PIXI.Loader.shared.add( "tut_module_" + i.toString(), "resources/img/tutorial/base/" + i.toString() + "@2x.png" )
        }
        //
        PIXI.Loader.shared.add( "button_on", "resources/img/button_on.png" )
            .add( "button_pressed", "resources/img/button_pressed.png" )
            .add( "transparent", "resources/img/transparent.png" );
        //
        PIXI.Loader.shared.add( "game_config", "resources/json/game_config.json" );
        //
        PIXI.Loader.shared.onComplete.once( this._onLoader_Complete, this );
        PIXI.Loader.shared.onProgress.add( this._onLoader_Progress, this );
        PIXI.Loader.shared.load();

        // Create sound load groups.
        const kArrSoundLoadGroup: Array<ISoundLoadGroup> = [ 
            { // music.
                arrExtension: [ "mp3" ],
                trackId: track_id.MUSIC,
                basePath: "resources/music/",
                arrName: [ "track_0" ]
            },
            { // sfx.
                arrExtension: [ "mp3" ],
                trackId: track_id.SFX,
                basePath: "resources/sound/",
                arrName: [ 
                    "dart_impact_0",
                    "dart_impact_1",
                    "dart_impact_2",
                    "dart_impact_3",
                    "dart_impact_4",
                    "dart_impact_5",
                    "dart_throw_0",
                    "dart_throw_1",
                    "dart_throw_2",
                    "dart_throw_3",
                    "dart_throw_4",
                    "dart_throw_5",
                    "game_over_lose",
                    "game_over_win",
                    "intro_spray_0",
                    "intro_spray_1",
                    "intro_spray_2",
                    "matchmaking_found",
                    "score_mult_bonus",
                    "ui_button_click",
                    "bust",
                    "checkout",
                    "bullseye" ] 
            } ];
        ServiceLocator.audio.load( kArrSoundLoadGroup );
    }

        private _onLoader_Complete( loader: PIXI.Loader, resources: PIXI.utils.Dict<PIXI.LoaderResource> ): void
        {
            if ( this._loadedFountCount == this._arrFontFaceObserver.length )
            {
                Object.assign( ServiceLocator.resources, resources );
                ServiceLocator.resources[ "game_logo" ] = this._resources.game_logo;
                loader.reset();

                window.setTimeout( () => { this._onComplete.dispatch(); }, 500 ); // show full bar.
            }
            else
            {
                window.setTimeout( this._onLoader_Complete.bind( this ), 500 );
            }
        }

        private _onLoader_Progress( loader: PIXI.Loader ): void
        {
            this._loadingBarMask.scale.x = loader.progress / 100;
        }

    public onLeave(): void
    {
        // Cleanup events.
        this._onComplete.dispose();
        this._onComplete = null;

        ServiceLocator.app.root.removeChild( this._root );
        this._root.destroy( { children: true } );
        this._root = null;

        super.onLeave();
    }

    // #endregion //
}